// removed by extract-text-webpack-plugin
module.exports = {"user-menu-left-wrap":"user-menu-left-wrap","my-business-menu-item":"my-business-menu-item","my-business-menu-wrap-item":"my-business-menu-wrap-item"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/user/menu/_UserMenu.scss
// module id = ./components/layouts/user/menu/_UserMenu.scss
// module chunks = 0